<section id="history" class="page-banner parallax-section">
    <div class="container-fluid text-center">
        <div class="row">
            <!-- <div class=" wow fadeInLeft col-md-1">
                <div class="d-flex" style="height: 100px;">
                    <div class="vr"></div>
                  </div>
            </div> -->
            <div class="wow fadeInUp offset-md-3 col-md-6 col-sm-7 " data-wow-delay="0.6s">
                <h1>Contact Us</h1>
                <ul>
                  <li>
                    <a routerlink="/" href="/">Home</a>
                  </li>
                  <li>Contact Us</li>
                </ul>
            </div>
        </div> 
    </div>
</section>

<section id="contact-details" class="parallax-section">
    <div class="d-flex justify-content-center align-items-center">
        <div class="row">
            <div class="col-md-4 d-flex align-items-center justify-content-center flex-column">
                <div class="contact-item circle fa-shake">
                    <i class="fa-solid fa-phone-volume fa-2xl" style="color: #00a331; margin-left: 20px;"></i>
                </div>
                <P>+63 917 845 6776</P>
                <p>+63 (2) 8 462 8500</p>
            </div>
            <div class="col-md-4 d-flex align-items-center justify-content-center flex-column text-center">
                <div class="contact-item circle fa-bounce">
                    <i class="fa-solid fa-location-dot fa-2xl" style="color: #00a303; margin-left: 25px;"></i>
                </div>
                <p>54 Molave Dr., Woodsrow 3 BF Martinville Manuyo Dos Las Piñas City PH 1744</p>
            </div>
            <div class="col-md-4 d-flex align-items-center justify-content-center flex-column">
                <div class="contact-item circle">
                    <i class="fa-solid fa-paper-plane-top fa-fade fa-2xl" style="color: #00b80c; margin-left: 22px;"></i>
                </div>
                <p>7107agencyofficial@gmail.com</p>
            </div>
        </div>
    </div>
</section>
<!-- CONTACT SECTION -->
<section id="contact" class="parallax-section">
	<div class="container">
		<div class="row">

			<div class="wow fadeInUp offset-md-1 col-md-5 col-sm-6" data-wow-delay="0.6s">
				<div class="contact_des">
					<h3>What We Do?</h3>
					<p>One of 7107 Islands Placement and Promotions, Inc.’s  primary objectives is to help Filipino workers land their dream jobs abroad, providing them with a chance to improve their lives and those of their families. They work with employers worldwide to source highly-skilled workers in various fields, including healthcare, hospitality, engineering, and construction.</p>
					<p>Employing a rigorous screening process to ensure that its candidates meet the employer's requirements. They conduct initial interviews to assess a candidate's qualifications and suitability, including language proficiency tests, practical skills assessments, and personality profiling. After this, candidates undergo further training to enhance their skills and improve their chances of securing employment abroad.</p>
				</div>
			</div>

			<div class="wow fadeInUp col-md-5 col-sm-6" data-wow-delay="0.9s">
				<div class="contact_detail">
					<div class="section-title">
						<h2>Inquire with us</h2>
					</div>
					<form action="#" method="post">
						<input name="name" type="text" class="form-control" id="name" placeholder="Name">
					  	<input name="email" type="email" class="form-control" id="email" placeholder="Email">
					  	<textarea name="message" rows="5" class="form-control" id="message" placeholder="Message"></textarea>
						<div class="col-md-6 col-sm-10">
							<input name="submit" type="submit" class="form-control" id="submit" value="SEND">
						</div>
					</form>
				</div>
			</div>

		</div>
	</div>
</section>
<div class="container mt-5">
    <div class="row">
        <div class="col-md-6 col-sm-12">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d406.07597060629575!2d120.99804116265423!3d14.469324979578454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sph!4v1690253918257!5m2!1sen!2sph" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
        <div class="col-md-6 col-sm-12">
            <img src="assets/images/7107-map.jpg" class="img-fluid" alt="">
        </div>
    </div>
</div>